import templateUrl from "emun.invoice/invoice-lines-table.htm";
import config from "emun.invoice/invoice.config";
import $appConfig from "servicestack/config";

export default {
  bindings: {
    invoice: "<",
    creditmemo: "<"
  },
  controller() {
    this.config = config;
    this.productImage = $appConfig.productImage.bind($appConfig);
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
